import { render, staticRenderFns } from "./history.vue?vue&type=template&id=40075f4e&scoped=true&"
import script from "./history.vue?vue&type=script&lang=js&"
export * from "./history.vue?vue&type=script&lang=js&"
import style0 from "./history.vue?vue&type=style&index=0&id=40075f4e&lang=scss&scoped=true&"
import style1 from "./history.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40075f4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40075f4e')) {
      api.createRecord('40075f4e', component.options)
    } else {
      api.reload('40075f4e', component.options)
    }
    module.hot.accept("./history.vue?vue&type=template&id=40075f4e&scoped=true&", function () {
      api.rerender('40075f4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/history.vue"
export default component.exports